// extracted by mini-css-extract-plugin
export default {"cartContainer":"WO","summarycontent":"XO","offset":"YO","leaf":"ZO","summaryclosed":"aP","summaryheader":"bP","summaryitems":"cP","summaryprice":"eP","buttonopen":"fP","buttondown":"gP","summaryfixed":"hP","usdnotification":"iP","renew":"jP","promowrapper":"kP","ordersummarywrap":"lP","simplewrap":"mP"};
    if(module.hot) {
      // 1714442370603
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  